import ReactApexChart from "react-apexcharts";

// Espera `inscriptions` con la forma que devuelve
// inscription/getPieChartDataByDateAndUser: { [categoryName]: count }
export const PieBarCategoriesInscriptionsChart = ({ inscriptions, colors }) => {
  const categories = Object.keys(inscriptions);
  const values = Object.values(inscriptions);

  const chartData = {
    series: values,
    options: {
      chart: {
        type: "polarArea",
      },
      stroke: {
        colors: ["#fff"],
      },
      fill: {
        opacity: 0.8,
      },
      labels: categories,
      legend: {
        position: "bottom",
      },
      yaxis: {
        show: false,
      },
      colors: colors,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="polarArea"
        height={500}
      />
    </div>
  );
};
